export function getPriceInfo(product, altosVerified) {
  const price = Number(product.price) || 0;
  const mrp = Number(product.mrp) || 0;
  const offer = Number(product.offer_price) || 0;
  if (altosVerified) return { unit: price, compareAt: mrp > price ? mrp : null };
  if (offer > 0) return { unit: offer, compareAt: mrp > offer ? mrp : null };
  return { unit: mrp > 0 ? mrp : price, compareAt: null };
}

export const discountPercent = (info) =>
  info.compareAt ? Math.round(((info.compareAt - info.unit) / info.compareAt) * 100) : 0;

export function cartSavings(lines, altosVerified) {
  return lines.reduce((sum, l) => {
    const info = getPriceInfo(l.product, altosVerified);
    return sum + (info.compareAt ? (info.compareAt - info.unit) * l.quantity : 0);
  }, 0);
}

export const MIN_PURCHASE_ALTOS = 599;
export const MIN_PURCHASE_REGULAR = 399;
export const minPurchaseFor = (altosVerified) => (altosVerified ? MIN_PURCHASE_ALTOS : MIN_PURCHASE_REGULAR);

export const HEAVY_ITEM_THRESHOLD_G = 500;
export const HEAVY_ITEM_MAX_QTY = 2;
export const isHeavyItem = (p) => (Number(p.weight_grams) || 0) >= HEAVY_ITEM_THRESHOLD_G;

// Buy 3 Get 1 Free scheme (per-product): buy up to 3; the 3rd earns 1 free.
export const isComboOffer = (p) => !!(p && p.buy3get1);
export const comboStep = (p) => 1;
export const comboMinQty = (p) => 1;
export const freeUnits = (p, qty) => (isComboOffer(p) ? Math.floor((Number(qty) || 0) / 3) : 0);

export const maxQtyFor = (p) => (isComboOffer(p) ? 3 : (isHeavyItem(p) ? HEAVY_ITEM_MAX_QTY : 99));

export function shippingCharge(totalGrams) {
  if (totalGrams > 5000) return 100;
  if (totalGrams > 3000) return 50;
  return 0;
}

export function computeShipping(settings, totalGrams, subtotal) {
  if (!settings) return shippingCharge(totalGrams);
  if (settings.shipping_mode === "flat") {
    if (Number(settings.free_above_amount) > 0 && subtotal >= Number(settings.free_above_amount)) return 0;
    return Number(settings.flat_charge) || 0;
  }
  if (totalGrams > Number(settings.mid_upto_grams)) return Number(settings.high_charge) || 0;
  if (totalGrams > Number(settings.free_upto_grams)) return Number(settings.mid_charge) || 0;
  return 0;
}

export const formatWeight = (grams) =>
  grams >= 1000 ? `${(grams / 1000).toFixed(grams % 1000 === 0 ? 0 : 1)} kg` : `${Math.round(grams)} g`;

const CATEGORY_PRIORITY = ["supplements", "vitamins", "hair care", "skincare", "personal care"];

// Categories are now ordered by the admin (backend returns them in display order),
// so we simply pass them through untouched.
export function orderCategories(cats = []) {
  return Array.isArray(cats) ? cats : [];
}
